import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { usersQueryKeys } from '../data';

export const useResetUserQueries = (): VoidFunction => {
  const queryClient = useQueryClient();

  const handleResetUserQueries = useCallback(() => {
    void queryClient.resetQueries({
      queryKey: [...usersQueryKeys.getUsers],
      exact: false,
    });
  }, [queryClient]);

  return handleResetUserQueries;
};
